import { useParams, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { execSeatableSql } from './seatable.js';

import NavHeader from './navheader.js';
import PageSections from './pagesections.js';
import Footer from './footer.js';

function Capabilities() {
    const { capability } = useParams();
    const [capabilityDesc, setCapabilityDesc] = useState('');
    
    useEffect(() => {
      async function fetchData() {
        const capabilitySql = `SELECT \`Desc\` FROM Subpages WHERE \`ShortDesc\` = '${capability}'`;
        setCapabilityDesc('');

        try {
          const capabilityRows = await execSeatableSql(capabilitySql);
          setCapabilityDesc(capabilityRows && capabilityRows.results[0]["Desc"]);
        } catch (err) {
          // setError(err);
        }
      }
      fetchData();
    }, [capability]);

    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            if (location.hash.substring(1) === 'top') {
                window.scrollTo({ top: 0, behavior: 'smooth'})
            } else {
                const element = document.getElementById(location.hash.substring(1));
                if (element) {
                    element.scrollMargin = -50;
                    element.scrollIntoView({ block: 'start', behavior: 'smooth' });
                }
            }
        }
    }, [location]);

    return (
        <div>
            <NavHeader mode="Subpages" capability={capabilityDesc} navBrand={capability} />
            <PageSections capability={capabilityDesc} />
        </div>
    )
}

export default Capabilities;